<div [className]="'logout'">
  <div class="form-signin text-center">
    <div>
      @if (isJTGO) {
        <img class="mb-4" src="assets/images/JT-GO-Master-Logo-RGB.png" alt="Jobtrain Login" width="200">
      } @else {
        <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200" data-testid="img-default-logo">
      }
    </div>
    <div class="w-100">
      @if (ssoConfig && ssoConfig.SingleSignOn === 'Yes') {
        <div class="okta-logout sso-login">
          @if (ssoConfig !==null && ssoConfig.SingleSignOn_Type === 'Okta') {
            <button class="btn btn-lg btn-cas-login btn-block btn_cas_login mt-2" href="#" (click)="OktaLogin()">{{'Login.OktaLogin' | translate}}</button>
          }
        </div>
      }
      @if (showMobileLink) {
        <br />
        <p class="text-center mt-5 mobilelink">@if (showMobileLink) {
          <a href="#" data-testid="p-goto-mobile-version" (click)="goToMobile()">{{ 'Login.GoToMobileVersion' | translate }}</a>
        }</p>
      }
    </div>
    <br />
    <p class="text-muted" data-testid="p-copyright" [ngClass]="{'resetParagraphMargin': showMobileLink}">&copy; {{ copyRight }}</p>
  </div>
</div>

